import React from 'react';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
import { SVGIcons } from 'src/common-ui/icons.enum';
import 'src/popup/steem/pages/app-container/home/resources-section/vp-circle-with-table.scss';
export const RCCircleSimple = ({ percentage, timeToFull, currentToken, todol, toeur, dolto, eurto, doleur, eurdol, div1, div2, chain, }) => {
    const getColor = () => {
        if (percentage >= 80)
            return '#00e676';
        if (percentage >= 50)
            return '#ff9800';
        return '#f44336';
    };
    const getLogo = () => {
        switch (chain) {
            case 'HIVE': return SVGIcons.WALLET_HIVE_LOGO_SMALL;
            case 'BLURT': return SVGIcons.WALLET_BLURT_LOGO_SMALL;
            case 'TIME': return SVGIcons.WALLET_TIME_LOGO_SMALL;
            default: return SVGIcons.WALLET_STEEM_LOGO_SMALL;
        }
    };
    const animatedStyle = {
        transition: "stroke-dasharray 0.6s ease-out",
    };
    return (React.createElement("div", { className: "vp-with-table" },
        React.createElement("div", { className: "circle-wrapper" },
            React.createElement("table", { className: "vp-table" },
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("svg", { width: "132", height: "80", viewBox: "0 0 120 80" },
                            React.createElement("ellipse", { cx: "60", cy: "40", rx: "60", ry: "25", stroke: "#333", strokeWidth: "12", fill: "none", opacity: "0.2" }),
                            React.createElement("ellipse", { cx: "60", cy: "40", rx: "60", ry: "25", stroke: getColor(), strokeWidth: "12", fill: "none", strokeDasharray: `${(percentage / 100) * 275} 275`, strokeLinecap: "round", style: animatedStyle }),
                            React.createElement("text", { x: "66", y: "46", textAnchor: "middle", className: "vp-text" },
                                percentage.toFixed(2),
                                "%"))),
                    React.createElement("tr", null,
                        React.createElement("div", { className: "time-to-full" }, timeToFull))))),
        React.createElement("table", { className: "vp-table" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null,
                        React.createElement(SVGIcon, { icon: getLogo(), className: "small-logo" })),
                    React.createElement("th", null, "to Fiat"),
                    React.createElement("th", null, "Fiat to"))),
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", null, div1),
                    React.createElement("td", null, todol),
                    React.createElement("td", null, dolto)),
                React.createElement("tr", null,
                    React.createElement("td", null, div2),
                    React.createElement("td", null, toeur),
                    React.createElement("td", null, eurto)),
                React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("sup", null, "121")),
                    React.createElement("td", null, eurdol),
                    React.createElement("td", null, doleur))))));
};
